<template>
  <div class="screen background">
    <div class="screen-container">
      <response-item
        class="wrong-response-item"
        v-for="wrongResponse in wrongResponses"
        :key="wrongResponse.id"
        :questionId="wrongResponse.id"
      />
      <div class="cta">
        <vv-button @click="$router.push({ name: 'home' })">{{
          $t('quiz.backDashboard')
        }}</vv-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { VvButton } from '@/components/common'
import ResponseItem from '@/components/quiz/responses/ResponseItem.vue'
import userMixin from '@/mixins/user'

export default {
  name: 'QuizWrongResponses',
  components: { VvButton, ResponseItem },
  mixins: [userMixin],
  computed: {
    ...mapGetters({ wrongResponses: 'wrongResponses' })
  }
}
</script>

<style lang="scss" scoped>
.wrong-response-item {
  margin-bottom: 60px;
}
</style>
